export const SET_AUTHORIZED_REP_INVITATION = 'SET_AUTHORIZED_REP_INVITATION';
export const SET_AR_INVITATION_EXISTS = 'SET_AR_INVITATION_EXISTS';
export const SET_PREV_ROUTE_BEFORE_INVITE = 'SET_PREV_ROUTE_BEFORE_INVITE';
